import { defineStore } from 'pinia';

export const useBlockBuilderStore = defineStore('blockBuilder', {
    state: () => ({
        selectedAttribute: {},
        droppedAttributes: [],
    }),
    getters: {
        getDroppedAttributes(state) {
            return state.droppedAttributes;
        },
        getSelectedAttribute(state) {
            return state.selectedAttribute;
        },
        getAttributesList(state) {
            let attribute_list = [];
            state.droppedAttributes.forEach((attribute, index) => {
                attribute_list.push({
                    position: index,
                    attribute_id: attribute.id,
                });
            });
            return attribute_list;
        },
    },
    actions: {
        moveAttributeUp(index) {
            const currentAttribute = this.droppedAttributes[index];
            const previousAttribute = this.droppedAttributes[index - 1];
            this.droppedAttributes.splice(index - 1, 2, currentAttribute, previousAttribute);
        },

        moveAttributeDown(index) {
            const currentAttribute = this.droppedAttributes[index];
            const nextAttribute = this.droppedAttributes[index + 1];
            this.droppedAttributes.splice(index, 2, nextAttribute, currentAttribute);
        },
        removeAttribute(index) {
            this.droppedAttributes.splice(index, 1);
        },
        setExistingAttributes(attributes) {
            this.droppedAttributes = attributes;
        },
    },
    persist: {
        enabled: true,
    },
});
